import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageUserList
 * @description
 * # manageUserList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'manageUserList',
    ($compile, $http, ENV, $ngRedux, $scope, $rootScope, $location, $timeout, Session) => {
      if (!$scope.isAdminUser) {
        $location.path('/');
      }
      if($location.path() == '/admin' || $location.path() == '/admin/') {
        $location.path('/admin/users/manage-users');
      }
      $scope.proURL = ENV.proURL;
      $scope.states = [];

      $scope.init = () => {
        $rootScope.userId = null;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.getStates($http, ENV).then((res) => {
        $timeout(() => {
          $scope.states = res;
        });
      });

      $scope.searchState = (query) => {
        return new Promise((resolve, reject) => {
          if ($scope.states && $scope.states.length > 0) {
            const payload = $scope.states.filter((state) =>
              state.name.toLowerCase().includes(query.toLowerCase()),
            );
            resolve({ states: payload }).then((res) => res);
          } else {
            reject({
              state: 'Not Found',
            });
          }
        });
      };

      $scope.createModal = async (content) => {
        angular.element(document.querySelector('.admin-overlay-modal')).remove();
        angular.element(document.querySelector('.admin-modal')).remove();
        let $body = $(content);
        let temp = $compile($body)($scope);
        await angular.element(document.body).append(temp);
        setTimeout(() => {
          angular.element(document.querySelector('.admin-modal')).addClass('display');
        }, 150);
      };

      $scope.makeAdmin = (id, groups) => {
        const newGroups = [1].concat(groups.map((group) => group.id));
        $scope.changeUserPermissions($http, ENV, id, newGroups).then(
          $timeout(() => {
            $rootScope.getData();
          }, 750),
        );
      };

      $scope.removeAdmin = (id, groups) => {
        const newGroups = groups.filter((group) => group.id !== 1).map((group) => group.id);
        $scope.changeUserPermissions($http, ENV, id, newGroups).then(
          $timeout(() => {
            $rootScope.getData();
          }, 750),
        );
      };

      $scope.makeSuperUser = (id, groups) => {
        const newGroups = [4].concat(groups.map((group) => group.id));
        $scope.changeUserPermissions($http, ENV, id, newGroups).then(
          $timeout(() => {
            $rootScope.getData();
          }, 750),
        );
      };

      $scope.removeSuperUser = (id, groups) => {
        const newGroups = groups.filter((group) => group.id !== 4).map((group) => group.id);
        $scope.changeUserPermissions($http, ENV, id, newGroups).then(
          $timeout(() => {
            $rootScope.getData();
          }, 750),
        );
      };

      $scope.makeDeveloperUser = (id, groups) => {
        const newGroups = [7].concat(groups.map((group) => group.id));
        $scope.changeUserPermissions($http, ENV, id, newGroups).then(
          $timeout(() => {
            $rootScope.getData();
          }, 750),
        );
      };

      $scope.removeDeveloperUser = (id, groups) => {
        const newGroups = groups.filter((group) => group.id !== 7).map((group) => group.id);
        $scope.changeUserPermissions($http, ENV, id, newGroups).then(
          $timeout(() => {
            $rootScope.getData();
          }, 750),
        );
      };

      $scope.authenticate = (id) => {
        $scope.setTemporaryUser();
        $scope.authenticateAsUser($http, ENV, id).then(async (res) => {
          Session.setTokens(res.access_token, res.refresh_token, res.expires_in);
          $rootScope.clearSearchTerm();
          let user_response = await $scope.checkAdminAuth(true);
          if (!user_response) {
            await $scope.checkAdminAuth(false);
            $scope.createModal(
              `<div class="admin-modal authentication-error"><h2>Authentication Error</h2><p class="error">The selected clinic user has no associated organizations and cannot log in to Pro.</p>` +
                '<button ng-click="hideModal();" type="submit">Ok</button></div>' +
                '<div class="admin-overlay-modal"></div>',
            );
          }
        });
      };

      $scope.table = {
        name: 'Manage Users',
        options: {
          endpoint: '/2.0/users/',
          endpoint_data_key: 'users',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: false,
          search_key: 'Users',
          search_required: true,
        },
        actions: [],
        columns: [
          {
            name: 'Date Created',
            options: {
              content: '{{ record.date_created }}',
              class: '',
            },
          },
          {
            name: 'Last Online',
            options: {
              content: '{{ record.last_online }}',
              class: '',
            },
          },
          {
            name: "User's Name",
            options: {
              content:
                '<a ng-if="(record.first_name || record.last_name) && !checkPermission(record.groups, 1) && !checkPermission(record.groups, 3) && !checkPermission(record.groups, 4) && !checkPermission(record.groups, 5) && !checkPermission(record.groups, 6)" href="#" ng-href="/admin/users/manage-users/{{ record.id }}">' +
                '{{ record.first_name }} {{ record.last_name }}' +
                '</a>' +
                '<br ng-if="record.contact_information.email && (record.first_name || record.last_name) && !checkPermission(record.groups, 3) && !checkPermission(record.groups, 4) && !checkPermission(record.groups, 5) && !checkPermission(record.groups, 6)" />' +
                '<a ng-class="{\'small email\': (record.first_name || record.last_name)}" ng-if="record.contact_information.email && !checkPermission(record.groups, 1) && !checkPermission(record.groups, 3) && !checkPermission(record.groups, 4) && !checkPermission(record.groups, 5) && !checkPermission(record.groups, 6)" href="#" ng-href="/admin/users/manage-users/{{ record.id }}">' +
                '{{ record.contact_information.email }}' +
                '</a>' +
                '<span ng-if="(record.first_name || record.last_name) && (checkPermission(record.groups, 1) || checkPermission(record.groups, 3) || checkPermission(record.groups, 4) || checkPermission(record.groups, 5) || checkPermission(record.groups, 6))">{{record.first_name}} {{record.last_name}}</span>' +
                '<br ng-if="record.contact_information.email && (record.first_name || record.last_name) && (checkPermission(record.groups, 1) || checkPermission(record.groups, 3) || checkPermission(record.groups, 4) || checkPermission(record.groups, 5) || checkPermission(record.groups, 6))" />' +
                '<span ng-if="record.contact_information.email && (checkPermission(record.groups, 1) || checkPermission(record.groups, 3) || checkPermission(record.groups, 4) || checkPermission(record.groups, 5) || checkPermission(record.groups, 6))">{{record.contact_information.email}}</span>',
              class: 'td-user',
            },
          },
          {
            name: 'Applications',
            options: {
              content: '<ul><li ng-repeat="app in record.applications">{{ app.name }}</li></ul>',
              class: 'list-column',
            },
          },
          {
            name: 'Organization(s)',
            options: {
              content: '<ul><li ng-repeat="org in record.organizations">{{ org.name }}</li></ul>',
              class: 'list-column',
            },
          },
          {
            name: 'Group(s)',
            options: {
              content: '<ul><li ng-repeat="group in record.groups">{{ group.name }}</li></ul>',
              class: 'list-column',
            },
          },
          {
            name: 'Action',
            options: {
              content:
                '<a href="" ng-href="/admin/users/manage-users/{{ record.id }}" ng-if="!checkPermission(record.groups, 1) && !checkPermission(record.groups, 3) && !checkPermission(record.groups, 4) && !checkPermission(record.groups, 5) && !checkPermission(record.groups, 6)" >View User</a>' +
                '<a href="" ng-if="currentUser.id != record.id && checkPermission(record.groups, 1) && !checkPermission(record.groups, 4)" ng-click="removeAdmin(record.id, record.groups)">Remove Admin Permissions</a>' +
                '<a href="" ng-if="currentUser.id != record.id && isSuperUser && !checkPermission(record.groups, 4) && !checkPermission(record.groups, 1) && !checkPermission(record.groups, 2)" ng-click="makeAdmin(record.id, record.groups)">Make Admin User</a>' +
                '<a href="" ng-if="currentUser.id != record.id && isSuperUser && checkPermission(record.groups, 4)" ng-click="removeSuperUser(record.id, record.groups)">Remove Super User Permissions</a>' +
                '<a href="" ng-if="currentUser.id != record.id && isSuperUser && !checkPermission(record.groups, 4) && checkPermission(record.groups, 1) && !checkPermission(record.groups, 2)" ng-click="makeSuperUser(record.id, record.groups)">Make Super User</a>' +
                '<a href="" ng-if="currentUser.id != record.id && isKittyhawkSuperuser && checkPermission(record.groups, 7) && !checkPermission(record.groups, 4)" ng-click="removeDeveloperUser(record.id, record.groups)">Remove Developer Permissions</a>' +
                '<a href="" ng-if="currentUser.id != record.id && isKittyhawkSuperuser && !checkPermission(record.groups, 7) && !checkPermission(record.groups, 4) && !checkPermission(record.groups, 2)" ng-click="makeDeveloperUser(record.id, record.groups)">Make Developer User</a>' +
                '<a ng-href="{{ proURL }}/login?impersonate={{record.id}}" target="_blank" ng-if="currentUser.id != record.id && checkPermission(record.groups, 3) && !checkPermission(record.groups, 2) && (isSuperUser && !checkPermission(record.groups, 1) || (isAdminUser && !checkPermission(record.groups, 1))) && !checkPermission(record.groups, 4)">Authenticate as User</a>' +
                '<span ng-if="currentUser.id == record.id">n/a</span>',
              class: 'td-action',
            },
          },
        ],
        filters: [
          {
            name: 'First Name',
            type: 'text_input',
            options: {
              class: 'text-input-filter',
              query_string_parameter: 'first_name',
              selected: '',
            },
          },
          {
            name: 'Last Name',
            type: 'text_input',
            options: {
              class: 'text-input-filter',
              query_string_parameter: 'last_name',
              selected: '',
            },
          },
          {
            name: 'Email',
            type: 'text_input',
            options: {
              class: 'text-input-filter above-divider',
              query_string_parameter: 'email',
              selected: '',
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'State',
            type: 'angucomplete',
            options: {
              class: 'state-filter above-divider',
              query_string_parameter: 'state',
              remove_all: true,
              remove_all_key: 'states',
              selected: [],
              selected_parameter: 'abbreviation',
              selected_key: ['name'],
              selected_remove_key: 'id',
            },
            angucomplete_parameters: {
              id: 'state-name',
              placeholder: 'State Name',
              pause: 1000,
              datafield: 'states',
              isclearafterselect: true,
              selectedobject: 'name',
              searchfields: 'name',
              titlefield: 'name',
              descriptionfield: null,
              minlength: 2,
              inputclass: 'form-control form-control-small',
              matchclass: 'highlight',
              searchfn: 'searchState',
              nextfn: null,
              onselect: null,
              preselected: [],
              isUser: false,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'User Type',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/users/groups/',
              choices_endpoint_data_key: 'user-groups',
              class: 'user-filter above-divider',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'groups',
              select_all: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Application Subscription',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/applications/',
              choices_endpoint_data_key: 'applications',
              class: 'application-filter above-divider',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'application_subscription',
              select_all: true,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Organizations',
            type: 'angucomplete',
            options: {
              class: 'organization-filter',
              query_string_parameter: 'organizations',
              remove_all: true,
              remove_all_key: 'organizations',
              search_endpoint: '/2.0/organizations/',
              search_endpoint_data_key: 'data',
              selected: [],
              selected_key: ['name'],
              selected_remove_key: 'id',
            },
            angucomplete_parameters: {
              id: 'organization-name',
              placeholder: 'Organization Name',
              pause: 1000,
              datafield: 'organizations',
              isclearafterselect: true,
              selectedobject: 'name',
              searchfields: 'name',
              titlefield: 'name',
              descriptionfield: null,
              minlength: 2,
              inputclass: 'form-control form-control-small',
              matchclass: 'highlight',
              searchfn: $scope.filterOrganizations,
              nextfn: $scope.filterOrganizationsPage,
              onselect: $scope.setSelectedOrganizations,
              preselected: [],
              isUser: false,
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Account Status',
            type: 'multiple_choice',
            options: {
              choices: {
                Active: { type: 'standard', state: true, value: 'true', order: 0 },
                Deactivated: { type: 'standard', state: true, value: 'false', order: 1 },
              },
              class: '',
              query_string_parameter: 'is_active',
              select_all: true,
            },
          },
          {
            name: 'Anonymization Status',
            type: 'multiple_choice',
            options: {
              choices: {
                Anonymized: { type: 'standard', state: true, value: 'true', order: 0 },
                'Not Anonymized': { type: 'standard', state: true, value: 'false', order: 1 },
              },
              class: '',
              query_string_parameter: 'is_anonymized',
              select_all: true,
            },
          },
        ],
        sort_options: {
          last_login: {
            state: false,
            value: '1',
            title: 'Last Online',
            order: 0,
          },
          date_joined: {
            state: true,
            value: '-1',
            title: 'Date Created',
            order: 1,
          },
          last_name: {
            state: false,
            value: '1',
            title: "User's Name",
            order: 2,
          },
        },
      };

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
